import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

export const FIELD_ERROR_MESSAGE_TO_TRANSLATION_MAP: Record<string, MessageDescriptor> = {
  Required: msg`Required`,
  'CUSTOM ERROR': msg`Translated custom error`,
  'Invalid email': msg`Invalid email`,
  'Please enter a valid email': msg`Please enter a valid email`,
  'Consent is required': msg`Consent is required to receive marketing emails from Rover.com and its affiliates.`,
  'A profile photo is required to continue.': msg`A profile photo is required to continue.`,
  'You must have experience caring for pets to offer pet care through Rover.': msg`You must have experience caring for pets to offer pet care through Rover.`,
  'Enter a whole number.': msg`Enter a whole number.`,
  'Please write at least 25 words.': msg`Please write at least 25 words.`,
  'Please enter no more than 35 characters.': msg`Please enter no more than 35 characters.`,
  'Number must be less than or equal to 100': msg`Number must be less than or equal to 100`,
  'Incorrect code': msg`This code is incorrect. Check your email and try again`,
  'Alpha numeric error': msg`This code is incorrect. The code is case sensitive and must only contain alphanumeric characters (A–Z and 0–9). Check your email and try again.`,
  'This field is required': msg`This field is required`,
  'This field is required.': msg`This field is required.`,
  'Please choose a day care type': msg`Please choose a day care type`,
  'Please choose a boarding option': msg`Please choose a boarding option`,
  'Enter your full name to sign the agreement.': msg`Enter your full name to sign the agreement.`,
  'Please select a reason': msg`Please select a reason`,
  'This password should contain at least 8 characters.': msg`This password should contain at least 8 characters.`,
  'This password should contain at least one lowercase and one uppercase character.': msg`This password should contain at least one lowercase and one uppercase character.`,
  'This password should contain at least one number.': msg`This password should contain at least one number.`,
  'This password should contain at least one special character.': msg`This password should contain at least one special character.`,
  'This password should not start or end with a space.': msg`This password should not start or end with a space.`,
  'Please enter at least 2 characters.': msg`Please enter at least 2 characters.`,
  'Please agree to our Terms of Service and Privacy Statement.': msg`Please agree to our Terms of Service and Privacy Statement.`,
  'The specified ZIP/postal/postcode is invalid.': msg`The specified ZIP/postal/postcode is invalid.`,
} as const;
